import { render, staticRenderFns } from "./SystemParam.vue?vue&type=template&id=effffbbe&scoped=true&"
import script from "./SystemParam.vue?vue&type=script&lang=js&"
export * from "./SystemParam.vue?vue&type=script&lang=js&"
import style0 from "./SystemParam.vue?vue&type=style&index=0&id=effffbbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effffbbe",
  null
  
)

export default component.exports